import React, { useState } from 'react';

const OutlierToggle = ({ onToggleChange }) => {
  const [showOutliers, setShowOutliers] = useState(false);

  // Function to toggle the visibility of outliers
  const toggleOutliers = () => {
    setShowOutliers(!showOutliers);
    onToggleChange(!showOutliers);
  };

  return (
    <div className="flex flex-col items-center justify-center">
      {/* Checkbox for toggling outliers */}
      <label className="inline-flex items-center my-auto">
        <input
          type="checkbox"
          className="form-checkbox h-5 w-5 text-gray-600"
          checked={showOutliers}
          onChange={toggleOutliers}
        />
        <span className="ml-2 text-gray-700">Show Outliers</span>
      </label>
    </div>
  );
};

export default OutlierToggle;
